import { UpdateUserBodyDto } from '@shared/core/users'
import { useMutation, useQueryClient } from 'react-query'
import { DEFAULT_GET_PROFILE_CACHE_KEY } from 'src/modules/user/hooks/use-profile'
import { ApiService } from 'src/services/api.service'

export function useOptimisticUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation((data: UpdateUserBodyDto) => ApiService.Profile.updateProfile(data), {
    onMutate: async (newData) => {
      await queryClient.cancelQueries(DEFAULT_GET_PROFILE_CACHE_KEY, {
        exact: true,
      })
      queryClient.setQueryData(DEFAULT_GET_PROFILE_CACHE_KEY, (prev: object) => {
        return {
          ...prev,
          ...newData,
        }
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries(DEFAULT_GET_PROFILE_CACHE_KEY, {
        exact: true,
      })
    },
  })
}
